export enum DeviceDataTypeDesktopEnum {
  MAGNETIC_FIELD = 'MAGNETIC_FIELD',
  ACCELERATION = 'ACCELERATION',

  POSITION = 'POSITION',
  ACTIVITY = 'ACTIVITY',
  PROXIMITY = 'PROXIMITY',
  MORTALITY_IMPLANT = 'MORTALITY_IMPLANT',
  VAGINAL_IMPLANT = 'VAGINAL_IMPLANT',
  SEPARATION = 'SEPARATION',
  DOSIMETER = 'DOSIMETER',

  GLOBALSTAR_CSQ = 'GLOBALSTAR_CSQ',
  IRIDIUM_CSQ = 'IRIDIUM_CSQ',
  GSM_CSQ = 'GSM_CSQ',
  IOT_CSQ = 'IOT_CSQ',

  VAGINAL = 'VAGINAL',

  LOGGER_ACCELERATION = 'LOGGER_ACCELERATION',
  LOGGER_MAGNETIC_FIELD = 'LOGGER_MAGNETIC_FIELD',
  LOGGER_PRESSURE = 'LOGGER_PRESSURE',
  LOGGER_LIGHT = 'LOGGER_LIGHT',
  LOGGER_TEMPERATURE = 'LOGGER_TEMPERATURE',

  DEBUG_LOGS = 'DEBUG_LOGS',

  COLLAR_LOGS = 'COLLAR_LOGS',

  MORTALITY = 'MORTALITY',

  //TODO incomplete?! camera missing?! check with martin/ gps+x. can you readout traps?
}
